// extracted by mini-css-extract-plugin
module.exports = {"container":"LastRotation_container__2PeBX","infoText":"LastRotation_infoText__1GeGx","buttons":"LastRotation_buttons__3KDZw"};